import { provideKeycloak } from 'keycloak-angular';
import { KeycloakInitOptions } from 'keycloak-js';

const params = new URLSearchParams(window.location.search);
const idPdv = params.get('idPdv');
const role = params.get('role');
const extranet = params.get('extranet');

const redirectUri = window.location.origin + '/resiliation/accueil' +
    (params.toString() ? '?' + params.toString() : '');

let clientId = redirectUri.includes('pro') ? 'resiliation-pro' : window.location.origin.includes('red') ? 'resiliation-red' : 'resiliation';
let location = window.location.origin;
let hostKc = 'https://www.sfr.fr/auth';


/* Pour la partie distrib , forcer  la gestion */
if (idPdv != null || (role != null && role.includes('DISTRIB')) || redirectUri.includes('portailsfr') || document.referrer.includes('portailsfr')) {
    clientId = 'resiliation-cc';
    // dans ce cadre test mode internet
    if(redirectUri.includes('distrib')){
     clientId = 'resiliation-dc';
    }
    location = 'https://portailsfr.espacesfr.sfr.fr';
    hostKc = 'https://portailsfr.espacesfr.sfr.fr/auth';
}

const provideInitOptions = (): KeycloakInitOptions => {
    return window.location.origin.includes('localhost')
        ? { checkLoginIframe: false }
        : {
            onLoad: 'login-required',
            checkLoginIframe: false,
            silentCheckSsoRedirectUri: location + '/silent-check-sso.html',
        };
}

if (window.location.origin.includes('cms')) {
    hostKc = 'https://cms.sfr.fr/auth';
} else if (window.location.origin.includes('pfv')) {
    hostKc = 'https://www.pfv.sfr.fr/auth';
}


export const provideKeycloakAngular = () =>
    provideKeycloak({
        config: {
            url: hostKc,
            realm: 'sfr',
            clientId
        },
        initOptions: provideInitOptions()
    });



